import React from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import BigButton from '../components/BigButton';
import { categories } from '../data/words';
import { useSpeech } from '../hooks/useSpeech';
import './Words.css';

const Words = () => {
    const history = useHistory();
    const { speak } = useSpeech();

    const handleCategoryClick = (cat) => {
        speak(cat.label);
        setTimeout(() => {
            history.push(`/words/${cat.id}`);
        }, 400);
    };

    return (
        <Layout title="Words" onBack={() => history.push('/')}>
            <div className="words-grid">
                {categories.map((cat) => (
                    <BigButton
                        key={cat.id}
                        label={cat.label}
                        icon={cat.emoji}
                        color={cat.color}
                        onClick={() => handleCategoryClick(cat)}
                        className="word-category-button"
                    />
                ))}
            </div>
        </Layout>
    );
};

export default Words;
